angular.module('bribac.components.claimButtons', [])
  .component('claimButtons', {
    templateUrl: 'claim-buttons-component.html',
    controller: 'ClaimButtonsComponentCtrl',
    bindings: {
      flavor: '<',
      permissions: '<',
      roles: '<',
      claimButtons: '<',
      currentAgent: '<',
      subject: '<'
    }
  })
  .controller('ClaimButtonsComponentCtrl', function(api, $scope, $timeout) {
    var $ctrl = this;

    staffSubGroup = 'Reps / Employees';

    $ctrl.canAddClaimsManually = $ctrl.currentAgent && $ctrl.currentAgent.subGroups.some(group => group.name === staffSubGroup);

    $ctrl.timer = null;

    $ctrl.addOrToggleClaim = function(claim) {
      if ($ctrl.activeClaim && $ctrl.activeClaim.claim === claim) {
        $ctrl.endManualClaim();
      } else {
        if ($ctrl.timer) {
          $timeout.cancel($ctrl.timer);
        }
        $ctrl.activeClaim = {
          claim: claim,
          startDate: new Date(),
          elapsedTime: '00:00:00'
        };
        $ctrl.updateElapsedTime();
      }
    };

    $ctrl.isPaused = false;
    $ctrl.pausedElapsed = 0;

    $ctrl.pauseActiveClaim = function() {
      if ($ctrl.timer) {
        $timeout.cancel($ctrl.timer);
      }
      $ctrl.isPaused = true;
      $ctrl.pausedElapsed = new Date() - $ctrl.activeClaim.startDate;
    };

    $ctrl.resumeActiveClaim = function() {
      if ($ctrl.isPaused) {
        $ctrl.activeClaim.startDate = new Date(new Date() - $ctrl.pausedElapsed);
        $ctrl.isPaused = false;
        $ctrl.updateElapsedTime();
      }
    };

    $ctrl.updateElapsedTime = function() {
      if ($ctrl.activeClaim && !$ctrl.isPaused) {
        const elapsed = Math.floor((new Date() - $ctrl.activeClaim.startDate) / 1000);
        const hours = Math.floor(elapsed / 3600);
        const minutes = Math.floor((elapsed % 3600) / 60);
        const seconds = elapsed % 60;
        $ctrl.activeClaim.elapsedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        $ctrl.timer = $timeout($ctrl.updateElapsedTime, 1000);
      }
    };

    // In controller
    $ctrl.cancelActiveClaim = function() {
      $ctrl.hidingActionButtons = true; // Hide buttons immediately
      $ctrl.cancellingClaim = true;
      if ($ctrl.timer) {
        $timeout.cancel($ctrl.timer);
      }
      const canceledClaimName = $ctrl.activeClaim ? $ctrl.activeClaim.claim.name : 'Unknown';
      $timeout(function() {
        $ctrl.activeClaim = null;
        $ctrl.cancellingClaim = false;
        $ctrl.hidingActionButtons = false;
        $ctrl.isPaused = false;         // Reset pause state
        $ctrl.pausedElapsed = 0;        // Reset paused elapsed time
        $ctrl.claimNotification = {
          type: 'warning',
          message: `Claim (${canceledClaimName}) has been canceled.`
        };
      }, 0);
    };

    $ctrl.endManualClaim = function() {
      if ($ctrl.timer) {
        $timeout.cancel($ctrl.timer);
      }

      const endDate = new Date();
      const elapsed = Math.floor((endDate - $ctrl.activeClaim.startDate) / 1000);
      const hours = Math.floor(elapsed / 3600);
      const minutes = Math.floor((elapsed % 3600) / 60);
      const seconds = elapsed % 60;
      const duration = `${hours}h ${minutes}m ${seconds}s`;

      const claimData = {
        subjectId: $ctrl.subject ? $ctrl.subject.id : null,
        claimEvent: $ctrl.activeClaim.claim.event,
        createdBy: $ctrl.currentAgent ? $ctrl.currentAgent.id : null,
        startDate: $ctrl.activeClaim.startDate.toISOString(),
        endDate: endDate.toISOString(),
      };

      api.createManualClaim(claimData)
        .then(function(response) {
          const subject = response.data.subject || $ctrl.subject;
          const claimEventName = response.data.cptCode.name || $ctrl.activeClaim.claim.name;
          $scope.$emit('claimAdded', response.data);
          $ctrl.claimNotification = {
            type: 'success',
            message: `Claim (${claimEventName}) added successfully to subject ${subject.firstName} ${subject.lastName} (ID: ${subject.id}). Duration: ${duration}.`
          };
          $ctrl.activeClaim = null;
        })
        .catch(function(error) {
          let msg = `Failed to add claim (${$ctrl.activeClaim.claim.name}) to subject ${$ctrl.subject ? $ctrl.subject.fullName : 'Unknown'} (ID: ${$ctrl.subject ? $ctrl.subject.id : 'Unknown'}).`;
          if (error && error.data && error.data.error) {
            msg += ` Error: ${error.data.error}`;
          }
          $ctrl.claimNotification = { type: 'danger', message: msg };
        })
        .finally(function() {
          $ctrl.isSubmitting = false;
        });
    };
  });